import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface CartOrderBackupInstructionsEntityParams {
  productStockStatuses: { product_id: number; stock_status: string }[];
}
export class CartOrderBackupInstructionsEntity extends BaseEntityClass {
  product_stock_statuses: { product_id: number; stock_status: string }[];
  constructor(params: CartOrderBackupInstructionsEntityParams) {
    super();
    this.type = "cart_order_backup_instructions_entity";
    this.entity_version = 1;
    this.product_stock_statuses = params.productStockStatuses;
  }
}
